export const LIFECYCLE = [
  "Filed",
  "Under Review",
  "Neutral Assigned",
  "Notice Sent",
  "In Mediation",
  "Hearing Scheduled",
  "Awaiting Award",
  "Resolved",
  "Closed",
];

export const STATUS_TONE = {
  "Filed": "neutral",
  "Under Review": "info",
  "Neutral Assigned": "info",
  "Notice Sent": "warning",
  "In Mediation": "warning",
  "Hearing Scheduled": "warning",
  "Awaiting Award": "warning",
  "Resolved": "success",
  "Closed": "success",
};

export const CASE_TYPES = [
  { value: "e-commerce", label: "E-commerce complaint" },
  { value: "loan", label: "Loan / NBFC dispute" },
  { value: "credit-card", label: "Credit card dispute" },
  { value: "contract", label: "Contract disagreement" },
  { value: "consumer", label: "Consumer issue" },
  { value: "other", label: "Other" },
];

export function inr(n) {
  if (n == null) return "—";
  return "₹" + Number(n).toLocaleString("en-IN", { maximumFractionDigits: 0 });
}

export function fmtDate(s) {
  if (!s) return "—";
  try { return new Date(s).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" }); }
  catch { return s; }
}

export function fmtDateTime(s) {
  if (!s) return "—";
  try { return new Date(s).toLocaleString("en-IN", { dateStyle: "medium", timeStyle: "short" }); }
  catch { return s; }
}
